import * as React from 'react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * App-wide toast renderer. Mount once near the top of the tree.
 *
 * Usage:
 * ```tsx
 * import { toast } from '@/ga-ui/components/custom/toaster';
 * toast.success('Application submitted');
 * toast.error('Something went wrong');
 * toast('Heads up', { description: 'Extra detail' });
 * ```
 */
export function Toaster(
  props: React.ComponentProps<typeof SonnerToaster>
): JSX.Element {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        classNames: {
          toast:
            'tw-bg-white tw-text-gray-900 tw-border tw-border-solid tw-border-gray-200 tw-shadow-lg tw-rounded-md',
          title: 'tw-text-sm tw-font-semibold',
          description: 'tw-text-sm tw-text-gray-600',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
